import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import useAPI from 'src/hooks/useAPI'
import PageCalling from 'src/components/common/PageCalling'
import useValid from 'src/hooks/useValid'
import { AllCheckStatus, JoinTermsValue, RecoilStateList, TelTypeState, uiData } from 'src/recoil/common'
import Timer from 'src/components/views/RopForm/Timer'
import { PramsKeys } from 'src/types/type'
import { useTelList } from 'src/hooks/useTelList'
import { Rop01CertInput, Rop01CertSummitBtn, Rop01PhoneVerificationWrap, Rop01TelInput, Rop01TelPhoneNumWrap, Rop01TelSelectorWrap, Rop01Telecoms } from 'src/styles/styledcomponent/views/Rop01/PhoneVerification'
import { useCheckTelecomIsBlock } from 'src/hooks/useCheckTelecomIsBlock'
import { useAutoInputGuard } from "src/hooks/useAutoInputGuard";

const PhoneVerification = (props: any): JSX.Element => {
    const { onMoveToElement, RefInput, submit } = props
    const { pcode} = useParams<PramsKeys>()

  const {
    TelType,
    PhoneNum,
    CertNum,
    CertCheck,
    Timeout,
    termsAgree,
    authKeyValue,
    TransId,
    TermsData,
  } = useRecoilValue(RecoilStateList)
  const [
    {
      layoutsConfirm: { submitBtn },
      layoutsInsert: {certs, agency },
    }
  ] = useRecoilState(uiData)

  const setTelType = useSetRecoilState(TelTypeState)

  const resetTermsAgree = useResetRecoilState(JoinTermsValue)
  const resetTerms = useResetRecoilState(AllCheckStatus)

  const telList = useTelList()
  const handleValid = useValid()

  const certApi = useAPI('requestSendCertNumber')
  const joinApi = useAPI('requestJoin')

  useCheckTelecomIsBlock()

  const { mutateAsync: getSendOtp, isLoading: certLoading } = certApi.useSetMutation({
    Telecom: TelType,
    PNumber: PhoneNum,
    Pcode: pcode,
  })

  const {
    mutateAsync: joinRequest,
    isLoading: submitLoading,
    isSuccess: submitSuccess,
    data: submitReturn,
  } = joinApi.useSetMutation({
    TranID: TransId,
    Telecom: TelType,
    PNumber: PhoneNum,
    PCode: pcode,
    ApprovalNumber: Number(CertNum),
    TermsIdx: TermsData?.TermsIdx,
    TermsAgree: termsAgree.join(""),
    authKey: authKeyValue,
  })
  const isJoinBusy = submit.isJoinSubmitting || submit.isVulnerableCheckPending || submitLoading
  const handleJoinOnKeyUp = useAutoInputGuard(() => submit.join(joinRequest))

  const certOnKeyupFunc = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
        submit.validationCert(getSendOtp)
      if (certInput) {
        setTimeout(() => {
          certInput.focus()
        }, 1000)
      }
    }
  }
  const joinOnkeyupFunc = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if(event.key === 'Enter' && TelType === 2) {
      document.getElementById("joinButton")?.focus()
    } else if (!isJoinBusy && TelType !== 2) {
      handleJoinOnKeyUp(event)
    }
  }
  const telecomSelector = async (option: number) => {
    setTelType(option)
    onMoveToElement()
    resetTermsAgree()
    resetTerms()
  }
  const certInput = document.getElementById('certInput')


  useEffect(() => {
    if (submitSuccess && submitReturn?.Header?.ErrCode === 0) {
      window.close()
      window.location.reload()
    }
  }, [submitSuccess, submitReturn])


  return (
    <Rop01PhoneVerificationWrap
      backgroundColor={certs.backgroundColor}
      borderColor={certs.borderColor}
    >
      <PageCalling active={certLoading || submitLoading} />
      <Rop01TelSelectorWrap>
        {telList?.map((telecom) => (
          <Rop01Telecoms
            key={telecom.idx}
            className={telecom.text}
            oneTelStyle={telList?.length === 1}
            bgActive={TelType === telecom.idx}
            actColor={agency.actColor}
            disabled={CertCheck}
            onClick={() => telecomSelector(telecom.idx)}
          />
        ))}
      </Rop01TelSelectorWrap>
      <Rop01TelPhoneNumWrap>
        <Rop01TelInput
          borderColor={certs.borderColor}
          type="tel"
          ref={RefInput}
          placeholder="휴대폰번호를 입력하세요."
          maxLength={11}
          value={PhoneNum}
          onChange={handleValid.phoneNumValid}
          onKeyUp={certOnKeyupFunc}
          disabled={CertCheck}
          autoFocus
        />
        {!CertCheck ? (
          <Rop01CertSummitBtn
            {...submitBtn}
            onClick={() => {
                submit.validationCert(getSendOtp)
              if (certInput) {
                setTimeout(() => {
                  certInput.focus()
                }, 1000)
              }
            }}
          >
            인증번호 전송
          </Rop01CertSummitBtn>
        ) : (
          <section>
            <Rop01CertInput
              id={'certInput'}
              type={'tel'}
              placeholder={'인증번호 입력'}
              maxLength={4}
              value={CertNum}
              onChange={handleValid.certNumValid}
              onKeyUp={joinOnkeyupFunc}
              autoComplete={'one-time-code'}
            />
            <Timer time={Timeout} />
          </section>
        )}
      </Rop01TelPhoneNumWrap>
    </Rop01PhoneVerificationWrap>
  )
}

export default PhoneVerification
